import React, {memo} from 'react';
import PropTypes from 'prop-types';
import Section from 'helpers/Section';
import LazyImage from 'helpers/LazyImage';
import espaEL from 'assets/images/espa/banner_el.svg';
import espaEN from 'assets/images/espa/banner_en.svg';

const EspaBanner = ({language}) => (
  <Section sectionClass="pb-2 text-center mb-5">
    <a
      href={`https://web.ferryscanner.com/elevate/elevate_startups_${language}.pdf`}
      target="_blank"
      rel="noreferrer noopener"
    >
      <LazyImage
        wrapperClass="d-flex justify-content-center"
        imgClass="w-1-1"
        src={language === 'el' ? espaEL : espaEN}
        width="505"
        height="100"
        title="Elevating Greek Startups against COVID 19"
        alt="Elevating Greek Startups against COVID 19"
      />
    </a>
  </Section>
);

EspaBanner.propTypes = {
  language: PropTypes.string.isRequired
};

export default memo(EspaBanner);
